import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const Button = styled.button`
	cursor: pointer;
	font-size: ${CONFIG.fontSizes.md};
	font-family: ${CONFIG.fonts.regular};
	background-color: ${CONFIG.colors.white};
	color: ${CONFIG.colors.primary};
	border: 2px solid ${CONFIG.colors.primary};
	border-radius: 3px;
	max-width: 150px;
	width: 100%;
	margin-top: 10px;
	padding: 8px 12px;
	text-align: center;
	outline: none;

	display: flex;
	align-items: center;
	justify-content: center;

	:disabled {
		opacity: 0.5;
		cursor: default;
	}

	&:focus {
		color: ${(props) => {
			if (props.color) {
				return `${props.color} !important`;
			} else {
				return `${CONFIG.colors.primary} !important`;
			}
		}};
		background-color: ${(props) => {
			if (props.backgroundColor) {
				return `${props.backgroundColor} !important`;
			} else {
				return `${CONFIG.colors.primaryLight} !important`;
			}
		}};
		border-bottom: 4px solid ${CONFIG.colors.primary} !important;
	}

	transition: 1s all;
`;

export const RadioButtonInt = styled.div`
	width: 16px;
	height: 16px;
	border-radius: 16px;
	background-color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.primary;
		} else {
			return CONFIG.colors.white;
		}
	}};
	color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.white;
		} else {
			return CONFIG.colors.primary;
		}
	}};
`;

export const RadioButton = styled.div`
	position: relative;
	cursor: pointer;

	border: 2px solid ${CONFIG.colors.primary};
	border-radius: 24px;
	width: 24px;
	height: 24px;
	outline: none;

	display: flex;
	align-items: center;
	justify-content: center;

	:hover {
		${RadioButtonInt} {
			background-color: ${CONFIG.colors.primary};
			transition: 0.3s all;
		}
	}
`;

export const OpenArrow = styled.div`
	width: 20px;
	height: 20px;
	${({ isOpen }) => (isOpen ? 'transform: rotate(180deg);' : '')}
`;

export const CoverageCell = styled.div`
	display: flex;
	flex-direction: row;
	background-color: ${CONFIG.colors.primaryLighter};
	width: 100%;
	height: 100px;
	padding: 20px;
	justify-content: space-between;
	align-items: center;
	@media (max-width: 1495px) {
		height: 150px;
	}
	@media (max-width: 1400px) {
		height: 160px;
	}
	@media (max-width: 1232px) {
		height: 215px;
	}
	@media (max-width: 1158px) {
		height: 115px;
	}
	@media (max-width: 996px) {
		height: 130px;
	}
	@media (max-width: 825px) {
		height: 170px;
	}
	@media (max-width: 780px) {
		height: 190px;
	}
	@media (max-width: 710px) {
		height: 250px;
	}
	@media (max-width: 560px) {
		height: 320px;
	}
`;

export const PackCell = styled.div`
	display: flex;
	flex-direction: row;
	background-color: ${CONFIG.colors.primaryLighter};
	width: 100%;
	height: 100px;
	justify-content: center;
	align-items: center;
	@media (max-width: 1495px) {
		height: 150px;
	}
	@media (max-width: 1400px) {
		height: 160px;
	}
	@media (max-width: 1232px) {
		height: 215px;
	}
	@media (max-width: 1158px) {
		height: 115px;
	}
	@media (max-width: 996px) {
		height: 130px;
	}
	@media (max-width: 825px) {
		height: 170px;
	}
	@media (max-width: 780px) {
		height: 190px;
	}
	@media (max-width: 710px) {
		height: 250px;
	}
	@media (max-width: 560px) {
		height: 320px;
	}
`;
